/* ==========================================================================
   Salon Editorial Commerce — core runtime
   Progressive enhancement only: every purchase flow works without this file.
   Contains: overlay manager, toasts, scroll reveal, quantity input, swipe
   rails, cart API helper, accordion group, back-to-top.
   ========================================================================== */

(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['theme']) return;
  window.__hwsLoaded['theme'] = true;


  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  /* ------------------------------------------------------------- helpers */

  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'details > summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function announce(message) {
    var region = document.querySelector('[data-live-region]');
    if (!region || !message) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var thousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = thousands + ',' + parts[1];
    var thousandsDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDot = thousandsDot + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, thousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, thousandsDot)
      .replace(/\{\{\s*amount\s*\}\}/g, withDot);
  }

  window.hwsFormatMoney = formatMoney;
  window.hwsAnnounce = announce;

  /* --------------------------------------------------------- Cart helper */

  var Cart = {
    sectionsToRender: function () {
      var ids = [];
      document.querySelectorAll('[data-cart-section]').forEach(function (el) {
        var id = el.getAttribute('data-cart-section');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    },

    request: function (route, body) {
      var sections = Cart.sectionsToRender();
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }
      return fetch(route, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            data.__error = true;
          }
          return data;
        });
      });
    },

    add: function (items) {
      return Cart.request(config.routes.cartAdd, { items: items });
    },

    change: function (payload) {
      return Cart.request(config.routes.cartChange, payload);
    },

    update: function (payload) {
      return Cart.request(config.routes.cartUpdate, payload);
    },

    renderSections: function (data) {
      if (!data || !data.sections) return;
      Object.keys(data.sections).forEach(function (id) {
        var markup = data.sections[id];
        if (typeof markup !== 'string') return;
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        document
          .querySelectorAll('[data-cart-section="' + id + '"]')
          .forEach(function (target) {
            var selector = target.getAttribute('data-cart-section-selector');
            var source = selector
              ? parsed.querySelector(selector)
              : parsed.querySelector('[data-cart-section="' + id + '"]');
            if (source) {
              target.innerHTML = source.innerHTML;
            }
          });
      });
      Cart.syncCount(data);
      Cart.syncShippingProgress();
      document.dispatchEvent(new CustomEvent('hws:cart:updated', { detail: data }));
      Reveal.scan();
    },

    /* De gratis-verzendingsmeter wordt door Liquid gerenderd met de
       winkelwagen van dat moment. Buiten de winkelwagenlade (bijvoorbeeld op de
       productpagina) bleef hij daarom op het oude bedrag staan — vaak € 0,00.
       De versie in de lade komt via de Section Rendering API wél bijgewerkt
       mee, dus die nemen we over. Zo blijft de bedragopmaak van Shopify zelf
       gelden en hoeven we niets in JS na te rekenen. */
    syncShippingProgress: function () {
      /* Niet op [data-cart-drawer-body] mikken: die marker wordt bij het
         verversen door zijn eigen inhoud vervangen en bestaat daarna niet meer
         in de DOM. De wrapper .cart-drawer__progress komt wel mee. */
      var source = document.querySelector(
        '.cart-drawer__progress [data-shipping-progress]'
      );
      if (!source) return;
      document.querySelectorAll('[data-shipping-progress]').forEach(function (el) {
        if (el === source) return;
        el.innerHTML = source.innerHTML;
      });
    },

    syncCount: function (data) {
      var count = null;
      if (typeof data.item_count === 'number') count = data.item_count;
      if (data.sections && count === null) count = null;
      if (count === null) return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
        el.setAttribute('data-count', count);
      });
    },

    fetchState: function () {
      return fetch(config.routes.root + 'cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        return r.json();
      });
    }
  };

  window.hwsCart = Cart;

  /* ----------------------------------------------------------- Overlays */

  var OverlayManager = {
    stack: [],
    lastFocus: null,
    /* Secties die tijdelijk boven het verduisterde scherm zijn getild, zie
       verhoogSectie(). */
    verhoogd: [],

    register: function () {
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-overlay-open]');
        if (opener) {
          var id = opener.getAttribute('data-overlay-open');
          if (document.getElementById(id)) {
            event.preventDefault();
            OverlayManager.open(id, opener);
          }
          return;
        }
        var closer = event.target.closest('[data-overlay-close]');
        if (closer) {
          /* Een link die óók de overlay sluit moet wél navigeren: alleen bij
             knoppen (of een link zonder href) de standaardactie blokkeren. */
          var isLink = closer.tagName === 'A' && closer.getAttribute('href');
          if (!isLink) event.preventDefault();
          var explicit = closer.getAttribute('data-overlay-close');
          OverlayManager.close(explicit || undefined);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && OverlayManager.stack.length) {
          event.stopPropagation();
          OverlayManager.close();
        }
        if (event.key === 'Tab' && OverlayManager.stack.length) {
          OverlayManager.trapFocus(event);
        }
      });

      var backdrop = document.querySelector('[data-overlay-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          OverlayManager.close();
        });
      }
    },

    open: function (id, trigger) {
      var el = document.getElementById(id);
      if (!el) return;
      if (OverlayManager.stack.indexOf(id) !== -1) {
        /* Eén paneel dat aan meerdere knoppen hangt (de score staat in de header
           én in de footer): dezelfde knop sluit het weer, een andere knop
           verhuist het paneel naar díe knop. Zonder dit deed de tweede knop
           niets, omdat het paneel al "open" stond. */
        if (el.hasAttribute('data-overlay-anchored') && trigger) {
          if (OverlayManager.anchored && OverlayManager.anchored.trigger === trigger) {
            OverlayManager.close(id);
          } else {
            OverlayManager.anchor(el, trigger);
          }
        }
        return;
      }
      if (el.hasAttribute('data-overlay-exclusive')) {
        OverlayManager.closeAll();
      }
      if (!OverlayManager.stack.length) {
        OverlayManager.lastFocus = trigger || document.activeElement;
      }
      OverlayManager.stack.push(id);
      el.setAttribute('aria-hidden', 'false');
      el.removeAttribute('hidden');
      document.documentElement.classList.add('hws-overlay-open');
      if (!el.hasAttribute('data-overlay-no-lock')) {
        document.documentElement.classList.add('hws-scroll-lock');
      }
      var backdrop = document.querySelector('[data-overlay-backdrop]');
      if (backdrop && !el.hasAttribute('data-overlay-no-backdrop')) {
        backdrop.hidden = false;
        OverlayManager.verhoogSectie(el);
      }
      if (el.hasAttribute('data-overlay-anchored')) {
        OverlayManager.anchor(el, trigger);
      }
      window.requestAnimationFrame(function () {
        var target =
          el.querySelector('[data-overlay-autofocus]') ||
          el.querySelector(focusableSelector);
        if (target) target.focus();
      });
      el.dispatchEvent(new CustomEvent('hws:overlay:open', { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent('hws:overlay:opened', { detail: { id: id } })
      );
    },

    /* Het mobiele menu werd grijs zodra het openging. Dat kwam niet door een
       kleurenschema: het menu staat in de headersectie, en die is sticky met een
       eigen z-index. Daarmee is de sectie een eigen stapelcontext, dus de
       z-index 100 van de drawer telt alleen bínnen de header. Het verduisterde
       scherm hangt op body-niveau met z-index 90 en kwam er dus overheen — een
       laagje van 45% zwart over het hele menu.

       Zolang de overlay openstaat tillen we die sectie boven het donkere scherm.
       Bij het sluiten gaat de oude waarde terug, zodat de header daarna weer
       netjes onder andere overlays blijft. */
    verhoogSectie: function (el) {
      var sectie = el.closest ? el.closest('.shopify-section') : null;
      if (!sectie) return;
      var stijl = window.getComputedStyle(sectie);
      if (stijl.position === 'static' || stijl.zIndex === 'auto') return;
      if (OverlayManager.verhoogd.indexOf(sectie) !== -1) return;
      sectie.setAttribute('data-overlay-z', sectie.style.zIndex || '');
      sectie.style.zIndex = '101';
      OverlayManager.verhoogd.push(sectie);
    },

    herstelSecties: function () {
      OverlayManager.verhoogd.forEach(function (sectie) {
        var oud = sectie.getAttribute('data-overlay-z') || '';
        if (oud) {
          sectie.style.zIndex = oud;
        } else {
          sectie.style.removeProperty('z-index');
        }
        sectie.removeAttribute('data-overlay-z');
      });
      OverlayManager.verhoogd = [];
    },

    /* Zet een klein paneel bij de knop die het opende, in plaats van midden op
       het scherm. Past het er onder niet meer, dan klapt het naar boven. Het
       pijltje wijst naar het midden van de knop; --arrow-x is ook het punt
       waar de openingsanimatie begint. */
    anchor: function (el, trigger) {
      if (!trigger || !trigger.getBoundingClientRect) return;
      var marge = 10;
      var rect = trigger.getBoundingClientRect();
      /* Meten mag pas als het paneel zichtbaar is: hiervoor stond het op
         display:none en waren breedte en hoogte 0. */
      var breedte = el.offsetWidth;
      var hoogte = el.offsetHeight;
      var links = rect.left;
      var maxLinks = window.innerWidth - breedte - marge;
      if (links > maxLinks) links = maxLinks;
      if (links < marge) links = marge;

      var boven = rect.bottom + marge;
      var omhoog = boven + hoogte > window.innerHeight - marge && rect.top - hoogte - marge > 0;
      if (omhoog) boven = rect.top - hoogte - marge;
      el.classList.toggle('review-popover--above', omhoog);
      el.classList.toggle('is-above', omhoog);

      el.style.left = Math.round(links) + 'px';
      el.style.top = Math.round(boven) + 'px';

      var pijl = rect.left + rect.width / 2 - links;
      if (pijl < 16) pijl = 16;
      if (pijl > breedte - 16) pijl = breedte - 16;
      el.style.setProperty('--arrow-x', Math.round(pijl) + 'px');

      /* Meebewegen zolang het open staat; de knop schuift immers met de pagina
         mee terwijl het paneel vast op het scherm staat. */
      OverlayManager.anchored = { el: el, trigger: trigger };
      if (!OverlayManager.anchorBound) {
        OverlayManager.anchorBound = true;
        var opnieuw = function () {
          var a = OverlayManager.anchored;
          if (!a || a.el.getAttribute('aria-hidden') === 'true') return;
          OverlayManager.anchor(a.el, a.trigger);
        };
        window.addEventListener('scroll', opnieuw, { passive: true });
        window.addEventListener('resize', opnieuw);
        /* Zonder donkere laag eroverheen sluit een klik buiten het paneel het;
           de knop zelf niet, want die opent en sluit al. */
        document.addEventListener('click', function (event) {
          var a = OverlayManager.anchored;
          if (!a || a.el.getAttribute('aria-hidden') === 'true') return;
          if (a.el.contains(event.target) || a.trigger.contains(event.target)) return;
          OverlayManager.close(a.el.id);
        });
      }
    },

    close: function (id) {
      if (!OverlayManager.stack.length) return;
      var target = id || OverlayManager.stack[OverlayManager.stack.length - 1];
      var index = OverlayManager.stack.indexOf(target);
      if (index === -1) return;
      OverlayManager.stack.splice(index, 1);
      var el = document.getElementById(target);
      if (el) {
        el.setAttribute('aria-hidden', 'true');
        el.dispatchEvent(new CustomEvent('hws:overlay:close', { bubbles: true }));
      }
      if (!OverlayManager.stack.length) {
        document.documentElement.classList.remove('hws-overlay-open');
        document.documentElement.classList.remove('hws-scroll-lock');
        var backdrop = document.querySelector('[data-overlay-backdrop]');
        if (backdrop) backdrop.hidden = true;
        OverlayManager.herstelSecties();
        if (OverlayManager.lastFocus && OverlayManager.lastFocus.focus) {
          OverlayManager.lastFocus.focus();
        }
        OverlayManager.lastFocus = null;
      }
    },

    closeAll: function () {
      while (OverlayManager.stack.length) {
        OverlayManager.close();
      }
    },

    isOpen: function (id) {
      return OverlayManager.stack.indexOf(id) !== -1;
    },

    trapFocus: function (event) {
      var id = OverlayManager.stack[OverlayManager.stack.length - 1];
      var el = document.getElementById(id);
      if (!el) return;
      var nodes = Array.prototype.filter.call(
        el.querySelectorAll(focusableSelector),
        function (node) {
          return node.offsetParent !== null;
        }
      );
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!el.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  window.hwsOverlay = OverlayManager;

  /* -------------------------------------------------------------- Toasts */

  var Toast = {
    show: function (message, options) {
      options = options || {};
      var region = document.querySelector('[data-toast-region]');
      if (!region) return null;
      var el = document.createElement('div');
      el.className = 'hws-toast';
      var text = document.createElement('span');
      text.className = 'hws-toast__text';
      text.textContent = message;
      el.appendChild(text);
      if (options.actionLabel && typeof options.onAction === 'function') {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hws-toast__action';
        button.textContent = options.actionLabel;
        button.addEventListener('click', function () {
          options.onAction();
          Toast.dismiss(el);
        });
        el.appendChild(button);
      }
      region.appendChild(el);
      announce(message);
      var delay = options.duration === 0 ? 0 : options.duration || 5000;
      if (delay) {
        window.setTimeout(function () {
          Toast.dismiss(el);
        }, delay);
      }
      return el;
    },

    dismiss: function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }
  };

  window.hwsToast = Toast;

  /* ------------------------------------------------------- Scroll reveal */

  var Reveal = {
    observer: null,

    init: function () {
      if (config.reveal === false || config.animation === 'none') {
        document.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.setAttribute('data-inview', '');
          el.setAttribute('data-revealed', '');
        });
        return;
      }
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.setAttribute('data-inview', '');
          el.setAttribute('data-revealed', '');
        });
        return;
      }
      Reveal.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-inview', '');
            Reveal.observer.unobserve(entry.target);
            Reveal.afronden(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.02 }
      );
      Reveal.scan();
    },

    /* Zodra het binnenkomen klaar is, mag de laaghint eraf: anders houdt de
       browser de sectie in een eigen laag en blijven kleurovergangen van knoppen
       daarin hangen. */
    afronden: function (el) {
      var klaar = function () {
        el.setAttribute('data-revealed', '');
      };
      var duur = 900;
      var stijl = window.getComputedStyle(el);
      var seconden = parseFloat(stijl.transitionDuration) || 0;
      if (seconden) duur = seconden * 1000 + 120;
      window.setTimeout(klaar, duur);
    },

    scan: function () {
      if (!Reveal.observer) return;
      document
        .querySelectorAll('[data-reveal]:not([data-inview])')
        .forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.9) {
            el.setAttribute('data-inview', '');
          } else {
            Reveal.observer.observe(el);
          }
        });
    }
  };

  window.hwsReveal = Reveal;

  /* ---------------------------------------------------- Quantity input */

  class HwsQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;
      this.addEventListener('click', this.onClick.bind(this));
      this.input.addEventListener('change', this.onChange.bind(this));
    }

    onClick(event) {
      var button = event.target.closest('button[data-quantity-step]');
      if (!button) return;
      event.preventDefault();
      var step = parseInt(button.getAttribute('data-quantity-step'), 10) || 1;
      var min = parseInt(this.input.getAttribute('min'), 10);
      var max = parseInt(this.input.getAttribute('max'), 10);
      var next = (parseInt(this.input.value, 10) || 0) + step;
      if (!isNaN(min) && next < min) next = min;
      if (!isNaN(max) && next > max) next = max;
      if (String(next) === String(this.input.value)) return;
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onChange() {
      var min = parseInt(this.input.getAttribute('min'), 10);
      var max = parseInt(this.input.getAttribute('max'), 10);
      var value = parseInt(this.input.value, 10);
      if (isNaN(value)) value = isNaN(min) ? 1 : min;
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) {
        value = max;
        announce(strings.quantityError || '');
      }
      this.input.value = value;
    }
  }

  if (!customElements.get('hws-quantity')) {
    customElements.define('hws-quantity', HwsQuantity);
  }

  /* --------------------------------------------------------- Swipe rail */

  class HwsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.bar = this.querySelector('[data-rail-bar]');
      this.label = this.querySelector('[data-rail-label]');
      this.onScroll = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      if (this.prev) {
        this.prev.addEventListener('click', this.step.bind(this, -1));
      }
      if (this.next) {
        this.next.addEventListener('click', this.step.bind(this, 1));
      }
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
    }

    itemWidth() {
      var first = this.track.firstElementChild;
      if (!first) return this.track.clientWidth;
      var style = window.getComputedStyle(this.track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    step(direction, event) {
      if (event) event.preventDefault();
      var perView = Math.max(1, Math.round(this.track.clientWidth / this.itemWidth()));
      var doel = this.track.scrollLeft + direction * this.itemWidth() * perView;
      var max = this.track.scrollWidth - this.track.clientWidth;
      doel = Math.max(0, Math.min(max, doel));
      var vanaf = this.track.scrollLeft;
      this.track.scrollTo({
        left: doel,
        behavior: config.animation === 'none' ? 'auto' : 'smooth'
      });
      /* Vloeiend scrollen wordt niet overal uitgevoerd: in combinatie met
         scroll-snap, met "beperk beweging" aan of in een ingebouwde weergave blijft
         de rij dan gewoon staan en lijkt de pijl kapot. Beweegt hij na een moment
         nog niet, dan zetten we de positie hard. */
      var track = this.track;
      window.setTimeout(function () {
        if (Math.abs(track.scrollLeft - vanaf) < 2) track.scrollLeft = doel;
      }, 220);
    }

    update() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var atStart = this.track.scrollLeft <= 2;
      var atEnd = this.track.scrollLeft >= max - 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd || max <= 2;
      var total = this.track.children.length;
      var perView = Math.max(1, Math.round(this.track.clientWidth / this.itemWidth()));
      var ratio = max > 0 ? this.track.scrollLeft / max : 0;
      if (this.bar) {
        var width = Math.min(100, (perView / Math.max(total, 1)) * 100);
        this.bar.style.width = width + '%';
        this.bar.style.transform =
          'translateX(' + ratio * (100 / Math.max(width, 1)) * (100 - width) + '%)';
      }
      if (this.label) {
        var firstVisible = Math.round(ratio * Math.max(total - perView, 0)) + 1;
        var lastVisible = Math.min(total, firstVisible + perView - 1);
        this.label.textContent =
          firstVisible +
          (lastVisible > firstVisible ? ' – ' + lastVisible : '') +
          ' ' +
          (strings.of || 'van') +
          ' ' +
          total;
      }
    }
  }

  if (!customElements.get('hws-rail')) {
    customElements.define('hws-rail', HwsRail);
  }

  /* ------------------------------------------------- Accordion grouping */

  class HwsAccordion extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-single') !== 'true') return;
      this.addEventListener('toggle', this.onToggle.bind(this), true);
    }

    onToggle(event) {
      var target = event.target;
      if (target.tagName !== 'DETAILS' || !target.open) return;
      this.querySelectorAll('details[open]').forEach(function (item) {
        if (item !== target) item.open = false;
      });
    }
  }

  if (!customElements.get('hws-accordion')) {
    customElements.define('hws-accordion', HwsAccordion);
  }

  /* ------------------------------------------------------- Link kopiëren */

  /* Stond eerder in component-facets.js, dat alleen op collectie- en
     zoekpagina's laadt. Op de productpagina en in artikelen deed de knop
     daardoor niets. theme.js staat op elke pagina. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-link]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-copy-link')).then(function () {
      if (window.hwsToast) window.hwsToast.show(strings.copied || 'OK');
    });
  });

  /* -------------------------------------------------- Sticky header sync */

  function stickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var mode = header.getAttribute('data-sticky-mode');
    var section = header.closest('.shopify-section') || header.parentElement;
    /* Bij 'compact' en 'nav' verdwijnen er rijen uit de header. Zolang de
       header in de flow staat, wordt het document daardoor korter en schiet de
       hele pagina omhoog zodra je begint te scrollen. Daarom leggen we eerst de
       hoogte van de sectie vast en halen we de header dan uit de flow. */
    var collapses = mode === 'compact' || mode === 'nav';
    var threshold = 120;

    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      var stuck = y > threshold;
      if (stuck === header.classList.contains('is-stuck')) return;
      if (collapses && section) {
        if (stuck) {
          section.style.height = header.offsetHeight + 'px';
          section.classList.add('is-header-fixed');
        } else {
          section.classList.remove('is-header-fixed');
          section.style.height = '';
        }
      }
      header.classList.toggle('is-stuck', stuck);
      publishOffset();
    }

    /* Op telefoon schuift de header mee: naar beneden scrollen verbergt hem,
       naar boven scrollen brengt hem terug. Op een klein scherm is die 64px
       anders permanent kwijt. Boven 990px blijft de header gewoon staan. */
    var lastY = window.scrollY || window.pageYOffset;

    function showHeader() {
      header.classList.remove('is-hidden');
    }

    function hideHeader() {
      header.classList.add('is-hidden');
    }

    function onScrollMobile() {
      if (!window.matchMedia('(max-width: 989px)').matches) {
        showHeader();
        return;
      }
      var y = Math.max(0, window.scrollY || window.pageYOffset);
      /* Bovenaan altijd zichtbaar. Dit is ook het vangnet: raakt de stand ooit
         uit de pas, dan klopt hij weer zodra je bovenaan komt. */
      if (y <= 160) {
        showHeader();
        lastY = y;
        return;
      }
      /* Drempel van 8px zodat hij niet flikkert bij een kleine duw. */
      if (y > lastY + 8) {
        hideHeader();
      } else if (y < lastY - 8) {
        showHeader();
      }
      lastY = y;
    }

    /* Niet de hóógte van de header doorgeven maar hoe ver zijn onderkant onder de
       bovenrand van het scherm zit. Dat is hetzelfde zolang de header gewoon staat,
       maar het verschil is groot zodra hij wegschuift: op een telefoon verbergt hij
       zich bij naar beneden scrollen (zie onScrollMobile), en deze waarde bleef dan
       de volle hoogte. Alles wat eronder plakt — de tintbalk, de filterkolom, het
       springen naar een anker — hing daardoor 163px te laag, met een strook erboven
       waar de inhoud zichtbaar langsschoof.

       Onder nul kan niet: dan zou er ruimte worden afgetrokken. */
    function publishOffset() {
      var onderkant = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty(
        '--header-offset',
        Math.max(0, Math.round(onderkant)) + 'px'
      );
    }

    /* De header schuift in en uit, dus de waarde moet tijdens het scrollen mee.
       Eén keer per beeldopbouw is genoeg en houdt het scrollen soepel. */
    var offsetGepland = false;
    function planPublishOffset() {
      if (offsetGepland) return;
      offsetGepland = true;
      requestAnimationFrame(function () {
        offsetGepland = false;
        publishOffset();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScrollMobile, { passive: true });
    window.addEventListener('scroll', planPublishOffset, { passive: true });
    /* De header schuift met een overgang weg; na afloop staat de eindstand pas
       vast, dus dan nog een keer. */
    header.addEventListener('transitionend', publishOffset);

    /* En de maat rechtstreeks van de header aflezen zodra die verandert. Meten
       vanuit de scrollafhandeling liep namelijk één stap achter: de header wisselt
       tussen 163px en 64px, maar de waarde werd vastgelegd vóórdat die wissel in de
       opmaak was verwerkt. Scrol je terug omhoog, dan groeide de header naar 163px
       terwijl alles wat eronder plakt nog op 64px stond — de header lag dan over de
       bovenkant van de tintbalk heen en je kon de bovenste tintfamilies niet meer
       aanklikken; alleen de onderste rij stak er nog onderuit.

       Een ResizeObserver vuurt ná de opmaak en dus op precies het juiste moment. De
       verwijzing moet bewaard blijven, anders ruimt de browser hem op. */
    if (typeof ResizeObserver === 'function') {
      window.__hwsHeaderWaarnemer = new ResizeObserver(publishOffset);
      window.__hwsHeaderWaarnemer.observe(header);
    }
    window.addEventListener(
      'resize',
      function () {
        /* Bij een andere breedte is de bewaarde hoogte niet meer geldig. */
        if (section && !header.classList.contains('is-stuck')) section.style.height = '';
        publishOffset();
      },
      { passive: true }
    );
    onScroll();
    publishOffset();
  }

  /* -------------------------------------------------------- Back to top */

  function backToTop() {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;
    function onScroll() {
      button.setAttribute(
        'data-visible',
        (window.scrollY || window.pageYOffset) > 600 ? 'true' : 'false'
      );
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    button.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: config.animation === 'none' ? 'auto' : 'smooth'
      });
    });
    onScroll();
  }

  /* ------------------------------------------------- Header height sync */

  function headerHeight() {
    var group = document.querySelector('[data-header-group]');
    if (!group) return;
    function measure() {
      document.documentElement.style.setProperty(
        '--header-height',
        group.offsetHeight + 'px'
      );
    }
    measure();
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(group);
    }
  }

  /* ------------------------------------------------ bezorgbelofte bijwerken
     "Voor 16:00 besteld, morgen in huis" stond vast in de instellingen en klopte
     daardoor niet op een zaterdag: er wordt dan niet verzonden. Deze functie
     rekent met dezelfde verzenddagen en cutoff als de datumregel en schrijft de
     juiste belofte terug:
       voor de cutoff op een verzenddag  -> "Voor 16:00 besteld, morgen in huis"
       daarna of op een niet-verzenddag  -> "Voor 23:59 besteld, dinsdag in huis"
     Zonder JavaScript blijft de tekst uit de instellingen staan. */
  /* De gegevens mogen op het element zelf staan, of één keer op een omhullend
     [data-delivery-config]. Dat tweede is er voor lijsten: de tintselector heeft
     174 rijen met dezelfde belofte, en die acht attributen per rij zouden de
     pagina onnodig zwaar maken. */
  function beloftewaarde(el, sleutel) {
    if (el.dataset[sleutel] !== undefined) return el.dataset[sleutel];
    var houder = el.closest('[data-delivery-config]');
    return houder ? houder.dataset[sleutel] : undefined;
  }

  function bezorgBelofte(root) {
    var basis = root || document;
    var lijst = Array.prototype.slice.call(basis.querySelectorAll('[data-delivery-promise]'));
    /* Is de wortel zelf het element (bij een enkel vervangen knooppunt), dan
       hoort hij er ook bij: querySelectorAll kijkt alleen naar de kinderen. */
    if (basis.nodeType === 1 && basis.hasAttribute && basis.hasAttribute('data-delivery-promise')) {
      lijst.unshift(basis);
    }
    lijst.forEach(function (el) {
      if (el.dataset.promiseDone === 'true') return;
      var dagen = (beloftewaarde(el, 'days') || '').split(',').filter(Boolean).map(Number);
      if (!dagen.length) return;
      var cutoffH = parseInt(beloftewaarde(el, 'cutoffHour'), 10);
      var cutoffM = parseInt(beloftewaarde(el, 'cutoffMinute'), 10) || 0;
      if (isNaN(cutoffH)) return;

      var nu = new Date();
      var verzend = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate());
      var naCutoff = nu.getHours() > cutoffH || (nu.getHours() === cutoffH && nu.getMinutes() >= cutoffM);
      var vandaagNogWeg = !naCutoff && dagen.indexOf(verzend.getDay()) !== -1;
      if (!vandaagNogWeg) {
        do { verzend.setDate(verzend.getDate() + 1); } while (dagen.indexOf(verzend.getDay()) === -1);
      }
      var bezorging = new Date(verzend);
      bezorging.setDate(bezorging.getDate() + 1);

      var morgen = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1);
      var isMorgen = bezorging.toDateString() === morgen.toDateString();
      /* Kan het vandaag nog weg, dan geldt de echte cutoff. Kan dat niet meer,
         dan mag de bezoeker de hele dag nog bestellen zonder dat het uitmaakt. */
      var tijd = vandaagNogWeg
        ? (beloftewaarde(el, 'cutoffLabel') || '')
        : (beloftewaarde(el, 'lateLabel') || '23:59');

      var tekst;
      if (isMorgen) {
        tekst = (beloftewaarde(el, 'tplTomorrow') || '').replace('%%TIME%%', tijd);
      } else {
        var taal = document.documentElement.lang || 'nl';
        var dagnaam;
        try {
          dagnaam = new Intl.DateTimeFormat(taal, { weekday: 'long' }).format(bezorging);
        } catch (e) { return; }
        tekst = (beloftewaarde(el, 'tplDay') || '')
          .replace('%%TIME%%', tijd)
          .replace('%%DAY%%', dagnaam);
      }
      if (!tekst) return;
      el.textContent = tekst;
      el.dataset.promiseDone = 'true';
    });
  }

  window.hwsDeliveryPromise = bezorgBelofte;

  /* Alles wat ná het opstarten in de pagina komt — aanbevelingen, de
     winkelwagenlade, quickshop, een gefilterd raster, de tintselector — kreeg de
     herberekening niet mee en bleef "Voor 16:00 besteld, morgen in huis" tonen,
     ook op een zondag. Elke injectie apart laten melden is broos: er komt altijd
     een plek bij die het vergeet. Daarom kijkt één waarnemer naar de hele pagina
     en werkt hij bij wat erbij komt. De functie slaat alles over wat al
     data-promise-done heeft, dus dit kost niets als er niets te doen valt. */
  function beloftesVolgen() {
    if (!('MutationObserver' in window)) return;
    var wachtend = false;
    var waarnemer = new MutationObserver(function (records) {
      if (wachtend) return;
      var raak = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return (
            (node.hasAttribute && node.hasAttribute('data-delivery-promise')) ||
            (node.querySelector && node.querySelector('[data-delivery-promise]'))
          );
        });
      });
      if (!raak) return;
      wachtend = true;
      window.requestAnimationFrame(function () {
        wachtend = false;
        bezorgBelofte();
      });
    });
    waarnemer.observe(document.body, { childList: true, subtree: true });
  }

  /* Een pagina die om 15:58 wordt geopend en om 16:05 nog openstaat, belooft nog
     steeds "Voor 16:00 besteld, morgen in huis" — de aftelbalk is dan al weg.
     Bij terugkeer naar het tabblad, en verder elke vijf minuten, laten we de
     beloftes opnieuw rekenen. data-promise-done gaat er dan af, anders slaat de
     functie ze over. */
  function beloftesVerversen() {
    var opnieuw = function () {
      document.querySelectorAll('[data-delivery-promise]').forEach(function (el) {
        delete el.dataset.promiseDone;
      });
      bezorgBelofte();
      document.dispatchEvent(new CustomEvent('hws:delivery:recalc'));
    };
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) opnieuw();
    });
    window.setInterval(opnieuw, 300000);
  }

  /* ---------------------------------------------------------------- boot */

  /* De footerkolommen staan in de opmaak open, zodat ze op een breed scherm
     naast elkaar staan en het ook zonder JavaScript werkt. Op een telefoon maakt
     dat de footer een halve schermlengte lang; daar klappen we ze dicht. Heeft de
     bezoeker er zelf aan gezeten, dan laten we het met rust. */
  function footerKolommen() {
    var smal = window.matchMedia('(max-width: 749px)');
    var groepen = document.querySelectorAll('.footer__details');
    if (!groepen.length) return;
    groepen.forEach(function (groep) {
      if (groep.dataset.footerReady === 'true') return;
      groep.dataset.footerReady = 'true';
      groep.addEventListener('toggle', function () {
        groep.dataset.handmatig = 'true';
      });
    });
    var zet = function () {
      groepen.forEach(function (groep) {
        if (groep.dataset.handmatig === 'true') return;
        groep.open = !smal.matches;
      });
    };
    zet();
    if (smal.addEventListener) {
      smal.addEventListener('change', function () {
        groepen.forEach(function (groep) { delete groep.dataset.handmatig; });
        zet();
      });
    }
  }

  function boot() {
    OverlayManager.register();
    bezorgBelofte();
    beloftesVolgen();
    beloftesVerversen();
    Reveal.init();
    stickyHeader();
    backToTop();
    headerHeight();
    footerKolommen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor lifecycle */

  document.addEventListener('shopify:section:load', function (event) {
    bezorgBelofte(event.target);
    Reveal.scan();
    stickyHeader();
    headerHeight();
    footerKolommen();
  });

  document.addEventListener('shopify:section:select', function (event) {
    var overlay = event.target.querySelector('[data-overlay-editor-open]');
    if (overlay && overlay.id) OverlayManager.open(overlay.id);
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var overlay = event.target.querySelector('[data-overlay-editor-open]');
    if (overlay && overlay.id) OverlayManager.close(overlay.id);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-slide-index]');
    if (slide) {
      var slideshow = slide.closest('hws-slideshow');
      if (slideshow && slideshow.goTo) {
        slideshow.goTo(parseInt(slide.getAttribute('data-slide-index'), 10) || 0);
      }
    }
    var details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
